import {Component} from 'react'
import NavBar from '../NavBar'
import ImageItem from '../ImageItem'
import TabItem from '../TabItem'
import GameOver from '../GameOver'
import './index.css'

class MatchGame extends Component {
  state = {
    timer: 60,
    tab: 'FRUIT',
    randomNumber: 0,
    score: 0,
    isGameOver: false,
  }

  componentDidMount() {
    this.intervalId = setInterval(this.tick, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  tick = () => {
    this.setState(prevState => {
      const newTimer = prevState.timer - 1
      if (newTimer <= 0) {
        clearInterval(this.intervalId)
        return {timer: 0, isGameOver: true}
      }
      return {timer: newTimer}
    })
  }

  onClickTab = tabId => {
    this.setState({tab: tabId})
  }

  onClickImg = id => {
    const {imagesList} = this.props
    const {randomNumber} = this.state
    const correctId = imagesList[randomNumber].id

    if (id === correctId) {
      this.setState(prevState => ({
        score: prevState.score + 1,
        randomNumber: Math.floor(Math.random() * imagesList.length),
      }))
    } else {
      clearInterval(this.intervalId)
      this.setState({isGameOver: true})
    }
  }

  onPlayAgain = () => {
    this.setState({
      isGameOver: false,
      score: 0,
      timer: 60,
      randomNumber: 0,
    })
    this.intervalId = setInterval(this.tick, 1000)
  }

  render() {
    const {tabsList, imagesList} = this.props
    const {timer, tab, randomNumber, score, isGameOver} = this.state

    const imageToMatch = imagesList[randomNumber]
    const filteredImages = imagesList.filter(each => each.category === tab)

    return (
      <div>
        <NavBar score={score} timer={timer} />
        <div className="main-container">
          {isGameOver ? (
            <GameOver score={score} onPlayAgain={this.onPlayAgain} />
          ) : (
            <>
              <img src={imageToMatch.imageUrl} alt="match" className="image" />

              <div className="tabs-container">
                {tabsList.map(each => (
                  <TabItem
                    key={each.tabId}
                    details={each}
                    isActive={each.tabId === tab}
                    onClickTab={this.onClickTab}
                  />
                ))}
              </div>

              <ul className="thumbnail-container">
                {filteredImages.map(each => (
                  <ImageItem
                    key={each.id}
                    details={each}
                    onClickImg={this.onClickImg}
                  />
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    )
  }
}

export default MatchGame
